<script>
import { designSystem } from 'tb-design_system-web'
import { ref } from 'vue'
import { useMeta } from 'vue-meta'

export default {
  name: 'DesignSystemDemo',

  components: {
    designSystem
  },

  setup() {
    useMeta({ title: 'DesignSystem' })
    return {}
  }
}
</script>

<template>
  <div>
    <design-system />
  </div>
</template>
